export default "/images/64e8fccfe96b8db458e4ce5c674714c5.avif";